// extracted by mini-css-extract-plugin
export default {"container":"SecurityRegistrationModal_container__7nbJw","title":"SecurityRegistrationModal_title__-3nKz"};